import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, logPageView } from '../services/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  // Initialize Google Analytics once when the app loads
  useEffect(() => {
    initGA();
  }, []);

  // Track page views whenever the location changes
  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
}; 